import { UserAvatarComponent } from '@app/shared/components/user-avatar/user-avatar.component';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { MxTaskbarService } from '@app/shared/services/mx-taskbar/mx-taskbar.service';
import { MxconnectionService } from '@app/shared/services/vault/mxconnection.service';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, fromEvent, Observable, Subscription } from 'rxjs';
import { ConnectToMxComponent } from '../connect-to-mx/connect-to-mx.component';
import { LoginStoreService } from '@app/root-store/login-store/login-store.service';
import { CreateMiniFromStepperComponent } from '@app/shared/component/create-mini-from-stepper/create-mini-from-stepper.component';
import { AddTrustTemplateDialogComponent } from '@app/shared/component/add-trust-template-dialog/add-trust-template-dialog.component';
import { AddTrustTemplate } from '@app/shared/component/add-trust-template-dialog/add-trust-template.interfaces';
import { map, take, takeWhile } from 'rxjs/operators';
import { AddDocumentComponent } from '@app/modules/vault/components/add-document/add-document.component';
import { MobileSideNavService } from '@app/shared/services/mobile-nav/mobile-nav.service';
import { CommonVaultSUbHeaderSubjectService } from '@app/modules/vault/components/common/common-vault-sub-header/common-vault-sub-header.component.service';
import { Router } from '@angular/router';
import { WorkSpaceService } from '@app/shared/services/work-space-service/work-space.service';
import { UserService } from '@app/shared/services';
import { ShareService } from '@app/shared/services/vault/share.service';
import { VaultStoreService } from '@app/root-store/vault-store/vault-store.service';
import { SharedVaultService } from '@app/shared/services/vault/shared-vault.service';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { PlaidService } from '@app/shared/services/plaid-service/plaid.service';
import { Store } from '@ngrx/store';
import { vaultStoreActions } from '@app/root-store/vault-store';
import { AsyncPipe, CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  SharedFloaterAction,
  SharedFloaterActionComponent
} from '@app/shared/component/shared-floater-action/shared-floater-action.component';
import { SharedFloaterPosition } from '@app/shared/component/shared-floater-action/shared-floater-position';
import { IndividualUserMemberComponent } from './individual-user-member/individual-user-member.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { CustomTooltipDirective } from '@app/shared/directives/custom-tooltip.directive';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TruncateStrPipe } from '@app/shared/pipes/truncate-str.pipe';
@AutoUnsubscribe()
@Component({
    selector: 'add-institution',
    templateUrl: './add-institution.component.html',
    styleUrls: ['./add-institution.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports:[
      CommonModule,
      FormsModule,
      SharedFloaterActionComponent,
      IndividualUserMemberComponent,
      MatExpansionModule,
      MatMenuModule,
      MatButtonModule,
      CustomTooltipDirective,
      DatePipe,
      MatTooltipModule,
      TruncateStrPipe,
      UserAvatarComponent,
      AsyncPipe
    ]
})
export class AddInstitutionComponent implements OnInit, OnDestroy {
  readonly embeddedFloaterPosition: SharedFloaterPosition = { embedded: true };

  readonly mxAccountFloaterActions: SharedFloaterAction[] = [
    { id: 'notInUse', label: 'Not In Use', icon: 'remove_circle_outline', iconOutlined: true, destructive: true }
  ];

  @Output() closeSideDrawerEmitter = new EventEmitter();
  @Input() isFromDiscovery?: boolean = false;
  @Input() switchFromUser?: boolean = false;
  @Input() selectedItemsArray?: Array<any> = [];
  subscription = new Subscription();
  isLoadingData = signal(true);
  mxDatList = signal([]);
  resizeObservable$: Observable<Event>;
  screenWidth: number;
  userId;
  workspaceId;
  worksapceUsers = [];
  currentWorkspaceUserId;
  currentActiveIndex = 0;
  loaderItems = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }];
  defaultFolders = [];
  connectedAccounts = signal([]);
  disconnectedAccounts = signal([]);
  isComponentActive = signal(true);
  expandedItems = signal([]);
  private linkCredentialSearchByAccount = new Map<string, string>();
  firstItemOnToggle: any = null;
  indexOfFirstItemOnToggle: number = -1;
  private worksapceMmbers$ = new BehaviorSubject<any[]>([]);

  private MxconnectionService = inject(MxconnectionService);
  private dialog = inject(MatDialog);
  private toastr = inject(ToastrService);
  private router = inject(Router);
  private _cd = inject(ChangeDetectorRef);
  private plaidService = inject(PlaidService);
  private _workSpaceService = inject(WorkSpaceService);
  private mxTaskbarService = inject(MxTaskbarService);
  private mobileNavService = inject(MobileSideNavService);
  private CommonVaultSUbHeaderSubjectService = inject(CommonVaultSUbHeaderSubjectService);
  private userService = inject(UserService);
  private shareService = inject(ShareService);
  private vaultService = inject(VaultStoreService);
  private sharedVaultService = inject(SharedVaultService);
  private elementRef = inject(ElementRef);
  private store = inject(Store);

  unlinkedMxTemplates: any[] = [];
  linkCredentialTemplates: any[] = [];
  linkCredentialDropdownAccount: any = null;
  /** Stable account id for dropdown visibility (avoids reference equality issues) */
  linkCredentialDropdownAccountId: string | null = null;
  /** Position for fixed dropdown (avoids overflow clipping) */
  linkCredentialDropdownPosition: { top: number; left: number; width: number } | null = null;
  linkCredentialFilteredTemplates: any[] = [];
  isLoadingLinkCredentialTemplates = false;
  /** Linked template per account: accountId -> { template, linkingId } */
  private linkedTemplateByAccountId = new Map<
    string,
    { template: any; linkingId?: number | string; templateId?: number | string }
  >();

  ngOnDestroy(): void {
    this.isComponentActive.set(false);
    this.mobileNavService.handleFinancialAccountSetupSidenav(false);
    this.CommonVaultSUbHeaderSubjectService.handleOpenMXDrawer(false);
    this.plaidService.clearSelectedInstitutionData();
    this.subscription.unsubscribe();
  }
  mouseEnterHandler(event: MouseEvent, assetExpansionPanel: MatExpansionPanel) {
    if (event.buttons && !assetExpansionPanel.expanded) {
      assetExpansionPanel.open();
    }
  }
  addInstitution(isFromPlaid = false) {
    const selectedInstitutionData = this.plaidService.getSelectedInstitutionData();
    const dialogRef: MatDialogRef<ConnectToMxComponent> = this.mxTaskbarService.openMxDialog(ConnectToMxComponent, {
      width: '400px',
      maxWidth: this.screenWidth < 480 ? '90vw' : '80vw',
      autoFocus: false,
      data: {
        title: 'Financial Institution',
        stop_form_creation: false,
        enable_linking: true,
        currentValutUserId: this.userId,
        ...(this.workspaceId && { workspace_id: this.workspaceId, workspace_user_id: this.currentWorkspaceUserId }),
        isFromPlaid: isFromPlaid,
        selectedInstitutionData: selectedInstitutionData,
      },
    });
    this.subscription.add(dialogRef.componentInstance.mxDialogMinimized.pipe(takeWhile(() => this.isComponentActive())).subscribe(() => {}));
    this.subscription.add(
      dialogRef
        .afterClosed()
        .pipe(takeWhile(() => this.isComponentActive()))
        .subscribe((val) => {
          if (isFromPlaid) {
            this.plaidService.clearSelectedInstitutionData();
          }
          if (val.success) {
            this.isLoadingData.set(true);
            this.getUserData();
          }
        })
    );
  }

  async addInstitutionThroughPlaid() {
    await this.plaidService.initializePlaidLink({
      includeTransactions: false,
      onSuccess: async (publicToken, metadata) => {
        this.addInstitution(true);
      },
    });
  }

  async reconnectToTheInstitutionThroughPlaid(account) {
    await this.plaidService.initializePlaidLinkUpdateMode(account.access_token, account.id, {
      onSuccess: async (publicToken, metadata) => {
        this.getUserData();
      },
      onExit: (error, metadata) => {
        if (error) {
          this.toastr.error('Failed to reconnect. Please try again.');
        }
      },
    });
  }

  disconnect(item) {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete Connection',
        materialIcon: 'trash',
        text: `Are you sure you want to delete the connection to ${item.name}?`,
        proceedTitle: 'Delete',
        checkBoxTitle: 'Delete all linked templates',
      },
    });
    this.subscription.add(
      sharedDialogRef
        .afterClosed()
        .pipe(takeWhile(() => this.isComponentActive()))
        .subscribe((data) => {
          const { confirmation, deleteAllChecked } = data;

          if (confirmation) {
            let data: {
              userId: string;
              memberGuid: string;
              id: string;
              delete_templates?: boolean;
              workspace_id?: string;
              workspace_user_id?: string;
            } = {
              userId: this.userId,
              ...(item.guid && { memberGuid: item.guid }),
              ...(item.access_token && { id: item.id }),
            };
            if (deleteAllChecked) data = { ...data, delete_templates: true };
            if (this.workspaceId) data = { ...data, workspace_id: this.workspaceId, workspace_user_id: this.currentWorkspaceUserId };
            if (data.memberGuid) {
              this.subscription.add(
                this.MxconnectionService.deleteUserMemberAccount(data)
                  .pipe(takeWhile(() => this.isComponentActive()))
                  .subscribe(() => {
                    this.toastr.success('Member deleted successfully.');
                    this.getUserData();
                  })
              );
            } else if (data.id) {
              this.subscription.add(
                this.userService
                  .deletePlaidAccountToken(data)
                  .pipe(takeWhile(() => this.isComponentActive()))
                  .subscribe(() => {
                    this.toastr.success('Plaid account token deleted successfully.');
                    this.getUserData();
                  })
              );
            }
          }
        })
    );
  }
  handleEmitEvents(value) {
    if (!!value.linkForm) {
      const { item } = value;
      this.moveAssetItem(item);
    } else if (!!value.openForm) {
      const { file } = value;
      const { vaultUserForm } = file;

      if (!!vaultUserForm) {
        const dialogOpen = this.dialog.open(AddDocumentComponent, {
          disableClose: true,
          data: { file: vaultUserForm, mode: 'edit', isintelligent: false, isfileListLoad: true },
          panelClass: 'full-window-dialog-add-document',
          autoFocus: false,
        });

        this.subscription.add(
          dialogOpen
            .afterClosed()
            .pipe(takeWhile(() => this.isComponentActive()))
            .subscribe(() => this.getUserData())
        );
      }
    } else {
      this.getUserData();
    }
  }

  reconnect(account) {
    const dialogRef: MatDialogRef<ConnectToMxComponent> = this.mxTaskbarService.openMxDialog(ConnectToMxComponent, {
      width: '400px',
      maxWidth: this.screenWidth < 480 ? '90vw' : '80vw',
      autoFocus: false,
      data: {
        currentValutUserId: this.userId,
        isUpdate: true,
        stop_form_creation: true,
        account,
        ...(this.workspaceId && { workspace_id: this.workspaceId, workspace_user_id: this.currentWorkspaceUserId }),
      },
    });

    this.subscription.add(
      dialogRef
        .afterClosed()
        .pipe(takeWhile(() => this.isComponentActive()))
        .subscribe((val) => (val.success ? this.getUserData() : ''))
    );
  }
  private loginService = inject(LoginStoreService);
  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.pipe(takeWhile(() => this.isComponentActive())).subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    if (this.router.url.includes('workspace')) {
      const parseUrl = this.router.url.split('/');
      this.workspaceId = parseUrl[2];
    }

    this.subscription.add(
      this.loginService.loginObject.pipe(takeWhile(() => this.isComponentActive())).subscribe((state) => {
        if (state && state.data && state.data.id) {
          this.userId = state.data.id;
        }
      })
    );

    if (this.workspaceId) {
      this.getWorkSpaceTypes();
    } else {
      this.getUserData();
    }

    this.loadUnlinkedMxTemplatesOnce();
  }

  loadUnlinkedMxTemplatesOnce(): void {
    this.subscription.add(
      this.sharedVaultService.getUnlinkedForm().subscribe({
        next: (res) => {
          const list = Array.isArray(res) ? res : [];
          list.forEach((t: any) => {
            t.connectionStatus = this.getConnectionStatusFromTemplate(t);
          });
          this.unlinkedMxTemplates = list;
          this._cd.markForCheck();
        },
        error: () => {
          this.unlinkedMxTemplates = [];
          this._cd.markForCheck();
        },
      })
    );
  }

  private getConnectionStatusFromTemplate(template: any): 'connected' | 'broken' | null {
    const mx = (template?.mx_connection_status ?? '').toString().trim();
    const plaid = (template?.plaid_connection_status ?? '').toString().trim();
    if (!mx && !plaid) return null;
    if (mx.toLowerCase() === 'connected' || plaid.toLowerCase() === 'connected') return 'connected';
    return 'broken';
  }

  getWorkSpaceTypes() {
    this.subscription.add(
      this._workSpaceService.getWorkSpaceTypes(this.workspaceId, 'data_feeds').subscribe((res) => {
        let updatedObject = [];
        this.indexOfFirstItemOnToggle = res.findIndex((obj) => obj.toggle === 'on');
        this.firstItemOnToggle = this.indexOfFirstItemOnToggle !== -1 ? res[this.indexOfFirstItemOnToggle] : null;
        res.forEach((element, index) => {
          let tempEllemt = {
            ...element,
            status: index === this.indexOfFirstItemOnToggle ? 'active' : 'inactive',
          };
          updatedObject.push(tempEllemt);
        });
        this.worksapceUsers = updatedObject;
        this.currentWorkspaceUserId = this.firstItemOnToggle.user_id;
        this.currentActiveIndex = this.indexOfFirstItemOnToggle ?? 0;
        this.worksapceMmbers$.next(updatedObject);
        if (this.firstItemOnToggle) {
          this.getUserData();
        } else {
          this.isLoadingData.set(false);
        }
        this._cd.detectChanges();
      })
    );
  }

  getUserData() {
    this.subscription.add(
      this.MxconnectionService.getUserStatusMX(this.workspaceId ? this.currentWorkspaceUserId : this.userId, this.workspaceId, 'all')
        .pipe(takeWhile(() => this.isComponentActive()))
        .subscribe((res) => {
          const mergedData = [...res.mx, ...res.plaid];
          this.mxDatList.set(mergedData);
          this.disconnectedAccounts.set(this.mxDatList().filter((data) => data?.connection_status !== 'CONNECTED'));
          this.connectedAccounts.set(this.mxDatList().filter((data) => data?.connection_status === 'CONNECTED'));
          this.isLoadingData.set(false);
          this._cd.markForCheck();
        })
    );
  }

  getLinkedTemplate(account: any): { template: any; linkingId?: number | string; templateId?: number | string } | null {
    const key = this.getAccountId(account);
    const fromMap = this.linkedTemplateByAccountId.get(key);
    const linking = account?.institution?.institution_linking;
    const fromApi = linking
      ? {
          template: {
            form_name: linking.vaultUserForm?.form_name ?? linking.form_name ?? linking.template_name,
            type: linking.vaultUserForm?.type ?? linking.type ?? linking.form_name,
            vault_user_form_id: linking.vault_user_form_id,
            id: linking.vault_user_form_id,
          },
          linkingId: linking.id,
          templateId: linking.vault_user_form_id,
        }
      : null;
    if (fromMap && fromMap.linkingId) return fromMap;
    if (fromApi) return fromApi;
    return fromMap ?? null;
  }

  hasLinkedTemplate(account: any): boolean {
    return !!this.getLinkedTemplate(account);
  }

  handleSidenavMenuNavigation(user_id: string, toggle: string, index: number) {
    if (index !== this.currentActiveIndex) {
      this.setStatusForSidenavMenu(index);
      this.currentWorkspaceUserId = user_id;
      this.connectedAccounts.set([]);
      this.disconnectedAccounts.set([]);
      this.mxDatList.set([]);
      this.expandedItems.set([]); // Clear expansion state when switching users
      if (toggle === 'on') {
        this.isLoadingData.set(true);
        this.getUserData();
      }
    }
  }

  setStatusForSidenavMenu(activeIndex) {
    if (activeIndex != -1) {
      for (let i = 0; i < this.worksapceUsers.length; i++) {
        this.worksapceUsers[i].status = i === activeIndex ? 'active' : 'inactive';
      }
      this.currentActiveIndex = activeIndex;
    } else {
      this.currentActiveIndex = undefined;
      for (let step of this.worksapceUsers) {
        step.status = 'inactive';
      }
    }
  }

  hasToggleOn$ = this.worksapceMmbers$.pipe(map((response) => response.some((obj) => obj.toggle === 'on')));

  getAccountLinkCredentialSearch(account: any): string {
    const key = account?.guid || account?.id || account?.name || '';
    return this.linkCredentialSearchByAccount.get(key) ?? '';
  }

  setAccountLinkCredentialSearch(account: any, value: string): void {
    const key = account?.guid || account?.id || account?.name || '';
    this.linkCredentialSearchByAccount.set(key, value);
    this.filterLinkCredentialTemplates(value);
    this._cd.markForCheck();
  }

  getAccountId(account: any): string {
    return account?.guid || account?.id || account?.name || '';
  }

  isLinkCredentialDropdownOpenFor(account: any): boolean {
    if (!this.linkCredentialDropdownAccountId) return false;
    return this.getAccountId(account) === this.linkCredentialDropdownAccountId;
  }

  openLinkCredentialDropdown(account: any): void {
    const accountId = this.getAccountId(account);
    if (this.linkCredentialDropdownAccountId === accountId) return;
    this.linkCredentialDropdownAccount = account;
    this.linkCredentialDropdownAccountId = accountId;
    this.linkCredentialDropdownPosition = null;
    this.linkCredentialTemplates = [];
    this.linkCredentialFilteredTemplates = [];
    this.loadLinkCredentialTemplates();
    this._cd.markForCheck();
    setTimeout(() => {
      this.updateLinkCredentialDropdownPosition();
      this._cd.markForCheck();
    }, 0);
  }

  private updateLinkCredentialDropdownPosition(): void {
    if (!this.linkCredentialDropdownAccountId) return;
    const escaped = CSS.escape(this.linkCredentialDropdownAccountId);
    const el = this.elementRef.nativeElement?.querySelector(
      `.link-credential-wrapper[data-account-id="${escaped}"]`
    ) as HTMLElement;
    if (el) {
      const rect = el.getBoundingClientRect();
      this.linkCredentialDropdownPosition = {
        top: rect.bottom + 8,
        left: rect.left,
        width: 360,
      };
    } else {
      this.linkCredentialDropdownPosition = {
        top: 100,
        left: 100,
        width: 360,
      };
    }
    this._cd.markForCheck();
  }

  closeLinkCredentialDropdown(): void {
    this.linkCredentialDropdownAccount = null;
    this.linkCredentialDropdownAccountId = null;
    this.linkCredentialDropdownPosition = null;
    this._cd.markForCheck();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.linkCredentialDropdownAccountId) return;
    const target = event.target as HTMLElement;
    if (target.closest?.('.link-credential-wrapper')) return;
    this.closeLinkCredentialDropdown();
  }

  /** Form type IDs for financial account templates (Link Credential dropdown) */
  private readonly FINANCIAL_ACCOUNT_FORM_IDS = [437, 2004, 2005];

  private loadLinkCredentialTemplates(): void {
    this.isLoadingLinkCredentialTemplates = true;
    this._cd.markForCheck();
    this.subscription.add(
      this.vaultService.vaultObject.pipe(take(1)).subscribe((state) => {
        const formIds = this.FINANCIAL_ACCOUNT_FORM_IDS;
        if (!formIds?.length) {
          this.linkCredentialTemplates = [];
          this.linkCredentialFilteredTemplates = [];
          this.isLoadingLinkCredentialTemplates = false;
          this._cd.markForCheck();
          return;
        }
        this.subscription.add(
          this.shareService.getFormsTypeUser({ formids: formIds }).subscribe({
            next: (res) => {
              this.linkCredentialTemplates = (res || []).map((form) => {
                const vaultName =
                  form.vault_name ??
                  form.vaultname ??
                  form.uname ??
                  form.vaultUserFolder?.vault?.name ??
                  form.vault_user_folder?.vault?.name ??
                  form.user_name;
                return {
                  vault_form_id: form.vault_form_id ?? form.id,
                  type: form.form_name || form.type,
                  type_template: form.type || form.form_name,
                  image: form.profile_image_url || form.image,
                  vault_name: vaultName,
                  vaultname: vaultName,
                  ...form,
                };
              });
              const search = this.linkCredentialDropdownAccount
                ? this.getAccountLinkCredentialSearch(this.linkCredentialDropdownAccount)
                : '';
              this.filterLinkCredentialTemplates(search);
              this.isLoadingLinkCredentialTemplates = false;
              this._cd.markForCheck();
            },
            error: () => {
              this.linkCredentialTemplates = [];
              this.linkCredentialFilteredTemplates = [];
              this.isLoadingLinkCredentialTemplates = false;
              this._cd.markForCheck();
            },
          })
        );
      })
    );
  }

  private filterLinkCredentialTemplates(search: string): void {
    const term = (search || '').toLowerCase().trim();
    if (!term) {
      this.linkCredentialFilteredTemplates = [...this.linkCredentialTemplates];
    } else {
      this.linkCredentialFilteredTemplates = this.linkCredentialTemplates.filter(
        (t) =>
          (t.type && t.type.toLowerCase().includes(term)) ||
          (t.type_template && t.type_template.toLowerCase().includes(term)) ||
          (t.form_name && t.form_name.toLowerCase().includes(term)) ||
          (t.vault_name && t.vault_name.toLowerCase().includes(term)) ||
          (t.vaultname && t.vaultname.toLowerCase().includes(term)) ||
          (t.uname && t.uname.toLowerCase().includes(term))
      );
    }
  }

  onLinkCredentialTemplateSelect(account: any, template: any): void {
    this.closeLinkCredentialDropdown();
    this.setAccountLinkCredentialSearch(account, '');
    const vaultUserFormId = template.vault_user_form_id ?? template.id;
    if (!vaultUserFormId) {
      this.toastr.error('Invalid template. Missing vault form.');
      return;
    }
    const doCreate = () => {
      const isMx = !!account?.guid;
      const institutionCode =
        account?.institution_code ?? account?.institution?.institution_id ?? account?.institution?.code ?? '';
      const payload: any = {
        vault_user_form_id: Number(vaultUserFormId) || vaultUserFormId,
        institution_plaid_id: isMx ? null : institutionCode,
        institution_mx_id: isMx ? institutionCode : null,
      };
      this.subscription.add(
        this.MxconnectionService.createInstitutionLinking(payload).subscribe({
          next: (res: any) => {
            const linkingId = res?.id ?? res?.data?.id;
            this.linkedTemplateByAccountId.set(this.getAccountId(account), {
              template: { ...template, form_name: template.form_name || template.type },
              linkingId,
              templateId: vaultUserFormId,
            });
            this.toastr.success('Credential linked successfully.');
            this.getUserData(); // Refresh so account.institution.institution_linking is synced for remove
            this._cd.markForCheck();
          },
          error: (err) => {
            const msg = err?.error?.message ?? err?.message ?? 'Failed to link credential.';
            this.toastr.error(msg);
            this._cd.markForCheck();
          },
        })
      );
    };
    const existing = this.getLinkedTemplate(account);
    const existingLinkingId = existing?.linkingId;
    if (existingLinkingId) {
      this.subscription.add(
        this.MxconnectionService.deleteInstitutionLinking({ id: existingLinkingId }).subscribe({
          next: () => {
            this.linkedTemplateByAccountId.delete(this.getAccountId(account));
            doCreate();
          },
          error: (err) => {
            this.toastr.error(err?.message || 'Failed to unlink previous credential.');
            this._cd.markForCheck();
          },
        })
      );
    } else {
      doCreate();
    }
  }

  onOpenLinkedTemplate(account: any): void {
    const linked = this.getLinkedTemplate(account);
    if (!linked?.template) return;
    const vaultUserForm =
      account?.institution?.institution_linking?.vaultUserForm ??
      { id: linked.template.vault_user_form_id ?? linked.templateId, form_name: linked.template.form_name, type: linked.template.type };
    const dialogRef = this.dialog.open(AddDocumentComponent, {
      disableClose: true,
      data: { file: vaultUserForm, mode: 'edit', isintelligent: false, isfileListLoad: true },
      panelClass: 'full-window-dialog-add-document',
      autoFocus: false,
    });
    this.subscription.add(
      dialogRef
        .afterClosed()
        .pipe(takeWhile(() => this.isComponentActive()))
        .subscribe(() => this.getUserData())
    );
  }

  onUnlinkCredential(account: any, event: Event): void {
    if (event) event.stopPropagation();
    const linked = this.getLinkedTemplate(account);
    const linkingId = linked?.linkingId;
    if (!linkingId) {
      this.toastr.error('Cannot delete: linking id not found.');
      return;
    }
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Remove Credential?',
        materialIcon: 'info',
        blueBg: true,
        text: 'Are you sure you want to remove the linked credential?',
        proceedTitle: 'Remove',
        showCancelBtn: true,
      },
    });
    this.subscription.add(
      sharedDialogRef
        .afterClosed()
        .pipe(takeWhile(() => this.isComponentActive()))
        .subscribe((result) => {
          if (result?.confirmation) {
            this.subscription.add(
              this.MxconnectionService.deleteInstitutionLinking({ id: linkingId }).subscribe({
                next: () => {
                  this.linkedTemplateByAccountId.delete(this.getAccountId(account));
                  this.toastr.success('Credential unlinked successfully.');
                  this.getUserData();
                  this._cd.markForCheck();
                },
                error: (err) => {
                  this.toastr.error(err?.message || 'Failed to unlink credential.');
                  this._cd.markForCheck();
                },
              })
            );
          }
        })
    );
  }

  openCreateNewCredential(account: any): void {
    this.setAccountLinkCredentialSearch(account, '');
    this.subscription.add(
      this.vaultService.vaultObject.pipe(take(1)).subscribe((state) => {
        const forms = state?.forms || [];
        const financialForms = forms.filter(
          (f) =>
            f?.organization_section === 'Financial Account Credential' ||
            (f?.type && String(f.type).toLowerCase().includes('financial account'))
          );
        const vaultFormId = 437;
        const vaultType =  'Financial Account';
        const loginUserId = this.userId;
        const personalSystemVault = (state?.vaults || []).find(
          (v: any) =>
            v?.type?.toLowerCase() === 'personal' &&
            v?.is_system === true &&
            String(v?.user_id) === String(loginUserId)
        );
        const vault_id = personalSystemVault?.id;
        const dialogRef = this.dialog.open<AddTrustTemplateDialogComponent, AddTrustTemplate>(
          AddTrustTemplateDialogComponent,
          {
            data: {
              vaultFormId: String(vaultFormId),
              vault_id: vault_id ?? undefined,
              inbox_attachment_id: undefined,
              title: vaultType,
              vaultType,
              hub_vault_user_form_id: undefined,
              origin: 'MxFinancialAccount',
              selectedAccounts: (account?.userAccounts || []).filter((a) => a.status === 'in use'),
            },
            panelClass: 'full-window-dialog-2',
          }
        );
        this.subscription.add(
          dialogRef
            .afterClosed()
            .pipe(takeWhile(() => this.isComponentActive()))
            .subscribe((result) => {
              this.getUserData();
              if (result) {
                const effectiveUserId = this.workspaceId ? this.currentWorkspaceUserId : this.userId;
                this.store.dispatch(new vaultStoreActions.GetVaultRequestAction(effectiveUserId, false));
                const template = {
                  vault_user_form_id: result?.vault_user_form_id ?? result?.id,
                  id: result?.id ?? result?.vault_user_form_id,
                  form_name: result?.form_name ?? result?.type ?? vaultType,
                  type: result?.type ?? vaultType,
                  ...result,
                };
                this.onLinkCredentialTemplateSelect(account, template);
              }
              this._cd.markForCheck();
            })
        );
      })
    );
    this._cd.markForCheck();
  }

  closeSideDrawer() {
    this.closeSideDrawerEmitter.emit();
  }
  selectedAccounts = signal([]);
  handleSelectedAccounts(data: Array<any> | undefined) {
    if (!data) return;

    const checkedItems = data.filter((item) => item.checked);
    const unCheckedItems = data.filter((item) => !item?.checked);
    const updatedArrayB = this.selectedAccounts().filter((itemB) => !unCheckedItems.some((itemA) => itemA.id === itemB.id));

    this.selectedAccounts.set([...new Set(updatedArrayB)]);
    this.selectedAccounts.set([
      ...new Set([
        ...checkedItems.filter((item) => !this.selectedAccounts().some((selected) => selected.id === item.id)),
        ...this.selectedAccounts()])]);
  }
  clearSession() {
    this.selectedAccounts.set([]);
    this.mxDatList.set(
      this.mxDatList().map((account) => {
        return {
          ...account,
          userAccounts: account.userAccounts.map((userAct) => ({ ...userAct, checked: false })),
        };
      })
    );
  }
  onMxAccountFloaterAction(actionId: string): void {
    if (actionId === 'notInUse') {
      this.notInUseChecklists('notInUse');
    }
  }

  moveChecklists(event) {
    if (event === 'clearSelection') {
      this.clearSession();
    } else if (event === 'move') {
      this.moveAssetItem();
    }
  }

  notInUseChecklists(event) {
    if (event === 'clearSelection') {
      this.clearSession();
    } else if (event === 'notInUse') {
      this.notInUseAssetItem();
    }
  }

  updateNotInUseStatus(item) {
    return new Promise((resolve) => {
      this.subscription.add(
        this.userService
          .updatemxMemberAccountStatus({
            user_account_guid: item.guid,
            user_account_status: 'not in use',
          })
          .subscribe((res) => {
            resolve(res);
          })
      );
    });
  }

  updateUserAccountPlaidStatus(item) {
    return new Promise((resolve) => {
      this.subscription.add(
        this.userService
          .updateUserAccountPlaidStatus({
            account_id: item.account_id,
            user_account_status: 'not in use',
          })
          .subscribe((res) => {
            resolve(res);
          })
      );
    });
  }

  notInUseAssetItem() {
    const promises = [];
    for (const item of this.selectedAccounts()) {
      if (item.status === 'in use') {
        if (item.guid) {
          promises.push(this.updateNotInUseStatus(item));
        } else if (item.account_id) {
          promises.push(this.updateUserAccountPlaidStatus(item));
        }
      }
    }
    Promise.all(promises).then(() => {
      this.clearSession();
      this.getUserData();
      this.toastr.success('Status updated successfully.');
      this.handleEmitEvents({ somePhone: true });
    });
  }

  moveAssetItem(item?: Record<any, any>) {
    const dialogRef = this.dialog.open<CreateMiniFromStepperComponent>(CreateMiniFromStepperComponent, {
      data: {
        inbox_attachment_id: undefined,
        vault_id: undefined,
        vaultFormId: 18,
        title: 'Move to',
        vaultType: 'Mx Financial Account',
        hub_vault_user_form_id: undefined,
        origin: 'MxFinancialAccount',
        selectedAccounts: !item ? this.selectedAccounts() : [item],
        discovery_sub_type_id: 'b22421a0-946e-4651-9e37-2d6ee07b0bf9',
      },
      panelClass: 'full-window-dialog-2',
    });
    this.subscription.add(
      dialogRef
        .afterClosed()
        .pipe(takeWhile(() => this.isComponentActive()))
        .subscribe((res) => {
          this.clearSession();
          if (res?.status) {
            this.getUserData();
          }
        })
    );
  }

  rearrangeByConnectionStatus(arr) {
    return arr.sort((a, b) => {
      if (a.connection_status !== 'CONNECTED' && b.connection_status === 'CONNECTED') {
        return -1; // Move disconnected to the top
      } else if (a.connection_status === 'CONNECTED' && b.connection_status !== 'CONNECTED') {
        return 1; // Move connected to the top
      }
      return 0; // Leave order unchanged if both are the same
    });
  }
  onPanelOpened(index) {
    this.expandedItems.set([...this.expandedItems(), index]);
  }
  onPanelClosed(index) {
    this.expandedItems.set([...this.expandedItems().filter((i) => i !== index)]);
    const closedAccount = this.mxDatList()[index];
    if (closedAccount && this.getAccountId(closedAccount) === this.linkCredentialDropdownAccountId) {
      this.closeLinkCredentialDropdown();
    }
  }
}
